// extracted by mini-css-extract-plugin
export default {"improvePrompt":"ImprovePrompt-module__improvePrompt--LWmCz"};